import { render, staticRenderFns } from "./WorkQualityCoordinationDialogWithTextAndMedia.vue?vue&type=template&id=39a74c8b&"
import script from "./WorkQualityCoordinationDialogWithTextAndMedia.vue?vue&type=script&lang=js&"
export * from "./WorkQualityCoordinationDialogWithTextAndMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QToolbar,QToolbarTitle,QCardSection,QCheckbox,QItemLabel,QInput,QCardActions,QBtn,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QCard,QToolbar,QToolbarTitle,QCardSection,QCheckbox,QItemLabel,QInput,QCardActions,QBtn,QInnerLoading,QSpinnerGears}, component.options.components || {})
